export default "__VITE_ASSET__w77mzzfR__"